import type { Professional } from '../types';
import { isPractitionerRole } from '../validators';
import { compact } from './array.utils';
import { titleCase } from './string.utils';

export function getNameWithPrefix(resource: Pick<Professional, 'name' | 'prefix'>) {
  const nameWithPrefix = compact<string>([resource?.prefix?.trim(), resource?.name])
    .filter((s) => s.length > 0)
    .join(' ');

  return titleCase(nameWithPrefix);
}

export function formatPractitionerRoleName(practitionerRoleName: string) {
  const splitted = practitionerRoleName.split(' @ ');
  return splitted.length === 2 ? splitted[0] : practitionerRoleName;
}

export function formatProfessionnalName(professionnal: Professional) {
  if (isPractitionerRole(professionnal)) {
    const formatedName = formatPractitionerRoleName(professionnal.name);
    return {
      ...professionnal,
      name: formatedName,
    };
  }
  return professionnal;
} // TODO handle it in BECA? : https://honestica.atlassian.net/browse/REB-357

/**
 * The name split every v2 enrichment needs: `displayName` never carries the civility prefix (feeds
 * initials computations), `fullName` always does (feeds tooltips). One seam so the split can't be
 * done inconsistently across senders and recipients — see DOCS-4737.
 */
export function splitPrefixedName(resource: Professional): {
  displayName: string;
  fullName: string;
} {
  const formatted = formatProfessionnalName(resource);
  return {
    displayName: formatted.name,
    fullName: getNameWithPrefix(formatted),
  };
}
